var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-title-element",attrs:{"contenteditable":_vm.editMode},on:{"blur":function($event){return _vm.editFormItemLabel('form-label', $event)},"focus":function($event){return _vm.setSelectedElement('form-label', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }